import {Class, ClassPayload} from './class'

export interface StudentPayload {
    IDSchueler: number
    Nachname: string
    Vorname: string
    Mail: string
    /* relations */
    klasse?: ClassPayload
}

export class Student {

    IDSchueler: number
    Nachname: string
    Vorname: string
    Mail: string
    /* relations */
    class: Class

    constructor(data: StudentPayload) {
        this.IDSchueler = data.IDSchueler
        this.Nachname = data.Nachname
        this.Vorname = data.Vorname
        this.Mail = data.Mail
        this.class = new Class(data.klasse || <ClassPayload>{})
    }

    fill(data: StudentPayload): this {
        this.IDSchueler = data.IDSchueler
        this.Nachname = data.Nachname
        this.Vorname = data.Vorname
        this.Mail = data.Mail
        this.class = new Class(data.klasse || <ClassPayload>{})
        return this
    }

    exists(): boolean {
        return !!this.IDSchueler
    }

    public get fullName(): string {
        return this.Nachname + ' ' + this.Vorname
    }

    payload(): StudentPayload {
        return {
            IDSchueler: this.IDSchueler,
            Nachname: this.Nachname,
            Vorname: this.Vorname,
            Mail: this.Mail
        }
    }
}
